import { Pipe, PipeTransform } from '@angular/core';
import { Account } from '../../../core/model/account-group/account.model';

/**
 * Transforms complex account object to human-friendly string.
 *
 * EXAMPLE:
 *  {
 *   'account': {
 *     'prefix': '000000',
 *     'number': '204533335',
 *     'bankCode': '0800'
 *    }
 *  }
 *  --> '204533335/0800'
 *
 *
 * USAGE IN CODE:
 * This pipe ships with shared module. You need to inject it in constructor similar to this:
 * constructor(private accountFormatPipe: AccountFormatPipe)
 *
 * Then you can do:
 * this.accountFormatPipe.transform(acc)
 *
 * USAGE IN TEMPLATE:
 * {{ account | ssfAccountFormat }}
 */
@Pipe({name: 'ssfAccountFormat'})
export class AccountFormatPipe implements PipeTransform {
    transform(account: Account): string {
        let prefixPart = !this.isPrefixFilled(account) ? '' : account.prefix + '-';
        let numberPart = !account.number || account.number === '' ? 'xxxxxxxxxx' : account.number;
        let bankCodePart = !account.bankCode || account.bankCode === '' ? '' : '/' + account.bankCode;
        if (this.isNothingFilled(account)) {
            return '';
        } else {
            return prefixPart + numberPart + bankCodePart;
        }
    }

    private isNothingFilled(account: Account): boolean {
        return !this.isPrefixFilled(account) && (!account.number || account.number === '')
            && (!account.bankCode || account.bankCode === '');
    }

    private isPrefixFilled(account: Account): boolean {
        // regExp serves for detection of prefixes '00000', '0' and similar
        let regExp = new RegExp('^[0\s]+$');
        return !!account.prefix && account.prefix !== '' && !regExp.test(account.prefix);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/pipes/account-format.pipe.ts